import { useRef, type ReactNode } from "react";

type BrandLogoUploaderProps = {
  logo?: string;
  fallbackIcon: ReactNode;
  onUploadFile?: (file: File) => void;
  onUploadClick?: () => void;
  onRemove: () => void;
  uploadRules?: ReactNode;
  uploadedFileName?: string;
  className?: string;
};

const BrandLogoUploader = ({
  logo,
  fallbackIcon,
  onUploadFile,
  onUploadClick,
  onRemove,
  uploadRules,
  uploadedFileName,
  className = "",
}: BrandLogoUploaderProps) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleUploadClick = () => {
    if (onUploadFile) {
      inputRef.current?.click();
      return;
    }

    onUploadClick?.();
  };

  return (
    <div className={`avatar-parent upload-logo-parent ${className}`}>
      {onUploadFile && (
        <input
          ref={inputRef}
          className="hidden"
          type="file"
          accept="image/png,image/jpeg,image/jpg"
          onChange={(event) => {
            const file = event.target.files?.[0];
            if (file) onUploadFile(file);
            event.target.value = "";
          }}
        />
      )}
      <div className="upload-avatar flex-cnt fx-d-col logo-upload">
        {logo ? (
          <div className="relative flex h-[80px] w-[80px] items-center justify-center rounded-full border-[1px] border-[#FB5F6626] bg-white">
            <img
              className="h-full w-full rounded-full object-contain p-[10px]"
              src={logo}
              alt=""
            />
            <button
              type="button"
              className="absolute right-[7px] top-[6px] flex h-[16px] w-[16px] -translate-y-1/4 translate-x-1/4 items-center justify-center rounded-full bg-[#666666] text-white transition-colors hover:bg-[#444444]"
              onClick={onRemove}
            >
              <svg width="6" height="6" viewBox="0 0 14 14" fill="none">
                <path
                  d="M1 1L13 13M1 13L13 1"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        ) : (
          <div
            className="logo-frame cursor-pointer"
            onClick={handleUploadClick}
          >
            {fallbackIcon}
          </div>
        )}

        {!logo && (
          <>
            <label
              className="browse-label upload-logo-heading"
              onClick={handleUploadClick}
            >
              <span className="browse-btn mt-10">Upload Logo</span>
            </label>
            {uploadRules}
          </>
        )}
        {logo && uploadedFileName && (
          <span className="mt-[10px] max-w-[180px] truncate rounded-[8px] bg-[#FFE9E9] px-[10px] py-[6px] !text-[12px] !leading-[110%] text-[#FB5F66]">
            {uploadedFileName}
          </span>
        )}
      </div>
    </div>
  );
};

export default BrandLogoUploader;
